import React from 'react';
const RolesConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/sessionMessage',
			component: React.lazy(() => import('./Session'))
		}
	]
};

export default RolesConfig;
